module.exports = __webpack_public_path__ + "static/media/csv.6cc3ed95.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/csv.svg
// module id = 131
// module chunks = 0